import getVariantsRawProductVariantUtil from 'modules/product-variant/utils/get-variants-raw'
import { AIRSHOP_PRODUCT_IDS } from 'modules/product/constants'

/**
 * @param  {ProductVariantCollection} productVariant
 */
export default function isParentProductVariantUtil (productVariant) {
  const productId = productVariant?.product_id
  // TODO omit when `updateSelectedColorVariantIdVariantAction` is triggered properly
  if (!AIRSHOP_PRODUCT_IDS.includes(productId)) {
    return true
  }

  return (
    !!getVariantsRawProductVariantUtil(productVariant)
  )
}
